import React from "react";
import { ReactComponent as VideoOnn } from "assets/img/icons/video-on.svg";
import { ReactComponent as MicOnnIcon } from "assets/img/icons/mic.svg";
import { ReactComponent as MicOffIcon } from "assets/img/icons/microphone.svg";
import { ReactComponent as VideoOff } from "assets/img/icons/video-call.svg";
import { useWaterCoolerContext } from "store/contexts/waterCoolerContext";

const styles = {
  actionButton: {
    display: "flex",
    justifyContent: "center",
  },
  icon: {
    cursor: "pointer",
    color: "#434343",
    background: "white",
    border: "none",
    borderRadius: "50px",
    margin: "0 10px",
    padding: "5px",
  },
};

export default ({ room, changeVideo, enableVideo, notSupported }) => {
  const classes = styles;
  const { microphone, toggleAudio, localVideo } = useWaterCoolerContext();

  const toggleVideo = async () => {
    if (!notSupported) {
      try {
        await room.localParticipant.videoTracks.forEach((publication) => {
          if (enableVideo) {
            localVideo.track.disable();
            publication.track.disable();
            changeVideo();
            return;
          }
          localVideo.track.enable();
          publication.track.enable();
          changeVideo();
        });
      } catch (e) {
        console.log(e);
      }
    }
    return;
  };

  return (
    <div style={classes.actionButton}>
      <div className="waterCoolerUserOptionButton">
        {enableVideo && (
          <VideoOnn
            className="mw-35"
            style={classes.icon}
            onClick={toggleVideo}
          />
        )}
        {!enableVideo && (
          <VideoOff
            className="mw-35"
            style={classes.icon}
            onClick={toggleVideo}
          />
        )}
        {microphone && (
          <MicOnnIcon
            className="mw-35"
            style={classes.icon}
            onClick={() => toggleAudio(room, false)}
          />
        )}
        {!microphone && (
          <MicOffIcon
            className="mw-35"
            style={classes.icon}
            onClick={() => toggleAudio(room, true)}
          />
        )}
      </div>
    </div>
  );
};
